// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","558":"c2133c21","685":"12e6b97f","733":"86795e09"}[chunkId] + ".chunk.js";
};